import { defineMessages } from 'react-intl'

const scope = `procurify.components.Chat`

export default defineMessages({
  sendBtnLabel: {
    id: `${scope}.sendBtnLabel`,
    defaultMessage: 'Send',
  },
  mentionsInputInstruction: {
    id: `${scope}.mentionsInputInstruction`,
    defaultMessage: 'type @ to start mentioning',
  },
  mentionsInputPlaceholder: {
    id: `${scope}.mentionsInputPlaceholder`,
    defaultMessage: 'Write a comment...',
  },
})
